// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"05d3fe52","834":"0f2f0752","971":"81874279"}[chunkId] + ".chunk.css";
};